import React from 'react';
import { Link } from "react-router-dom";
import { Typography } from 'antd';
import { Card, Avatar, List, Form, Input, Button, Spin, Skeleton, notification, Popconfirm } from 'antd';
import { observer } from "mobx-react";
import { autorun } from 'mobx';

import { UserStoreContext } from './AppContexts';

import { normalizeMatchPath } from './common';

@observer
class Users extends React.Component {

	static contextType = UserStoreContext;

	componentDidMount() {
		if (this.context.items.length == 0){ //prevents re-fetching the store. You may want to use react-router-cache-route instead
			this.context.load();
		}
		this.refetchOnInsertDisposer = autorun( () => { //this code reloads the userlist when something is inserted
			console.log('check if needs refetching the store');
			if (this.context.dirty){
				this.context.load();
			}
		});
		console.log(this);
	}

	componentWillUnmount() {
		console.log('Users componentWillUnmount');
		if (this.refetchOnInsertDisposer){
			this.refetchOnInsertDisposer();
		}
	}

	removeItem(id, item, evt) {
		console.log('removing ' + id);
		this.context.delete(id).then( () => {
			notification.success({
				message: 'Success',
				description: 'User deleted successfully',
				duration: 4
			});
		}).catch( (err) => {
			notification.error({
				message: 'Error',
				description: `Cannot delete the user. Please try again.\n${err && err.message || ''}`,
				duration: 8
			});
		});
	}

	render() {
		console.log(this.props);
		return (
		<>
			<Typography.Title level={3}>Users</Typography.Title>
			<Typography.Paragraph className='text-right'>
				<Link to={`${normalizeMatchPath(this)}/new`}><Button icon='plus' size='large' type='primary'>add user</Button></Link>
			</Typography.Paragraph>
			{ this.context.isLoading ?
				(
				<>
					<Skeleton active avatar paragraph={{ rows: 1 }} />
					<Skeleton active avatar paragraph={{ rows: 1 }} />
					<Spin size="default" tip="Loading..." />
				</>
				) : null }
			{ !this.context.isLoading &&
			<List itemLayout="horizontal" dataSource={this.context.items.slice()}
			renderItem={item => (
				<List.Item key={item.id}
				  actions={!this.context.isLoading && 
				  	[	
						<Popconfirm title="Do you really want to delete this user?" onConfirm={this.removeItem.bind(this, item.id, item)} okText="Yes" cancelText="No">
							<a href="#">delete</a>
						</Popconfirm>,
						,<Link to={`${normalizeMatchPath(this)}/view/${item.id}`}>edit</Link>
					]
				}>
					<Skeleton loading={this.context.isLoading} active avatar>
						<List.Item.Meta
							avatar={<Avatar icon="user" />}
							title={item.name}
							description={item.email} />
					</Skeleton>
				</List.Item>
			)} />
			}
		</>
		)
	}
}


const UserDetailForm = Form.create({
	name: 'user-detail',
	onFieldsChange(props, changedFields) {
		props.onChange(changedFields);
	},
	mapPropsToFields(props) {
		//console.log(props);
		return {
			email: Form.createFormField({
				...props.email,
				value: props.email.value,
			}),
			name: Form.createFormField({
				...props.name,
				value: props.name.value,
			}),
			password: Form.createFormField({
				...props.password,
				value: props.password.value,
			}),
		};
	},
	/*onValuesChange(_, values) {
		console.log(values);
	},*/
})((props) => {
	const formItemLayout = {
		labelCol: {
			xs: { span: 24 },
			sm: { span: 8 },
		},
		wrapperCol: {
			xs: { span: 24 },
			sm: { span: 16 },
		},
	};
	const { getFieldDecorator } = props.form;

	let handleSubmit = (e) => {
		//console.log('internal handle submit');
		e.preventDefault();
		props.form.validateFieldsAndScroll((err, values) => {
			if (!err) {
				props.onSubmit(values);
			}
		});
	};

	return (
		<Form className='user-edit' {...formItemLayout} onSubmit={handleSubmit}>
			<Form.Item label='E-mail'>
			{ getFieldDecorator('email', {
				rules: [ { type: 'email', message: 'The input is not valid E-mail' }
					 ,{ required: true, message: 'Please insert the E-mail' }
				]
			})( <Input type="email" placeholder="E-mail" />) }
			</Form.Item>
			<Form.Item label='Name'>
			{ getFieldDecorator('name', {
				rules: [ { required: true, message: 'Please insert the name of the user' } ]
			})( <Input placeholder="name and surname" />) }
			</Form.Item>
			<Form.Item label='Password'>
			{ getFieldDecorator('password', {
				//required only for new users
				rules: props.userId ? [] : [ { required: true, message: 'Please insert a password' } ]
			})( <Input.Password />) }
			</Form.Item>
			<Form.Item>
				<Button type="primary" htmlType="submit">Save</Button>
			</Form.Item>
			{ props.saving && <Spin size="small" tip="Saving..." /> }
		</Form>
	);
});

@observer
class UserDetail extends React.Component {
	static contextType = UserStoreContext;

	state = {
		loading: true
		,saving: false
		,fields: {
			email: { value: '' }, name: { value: ''}, password: { value: '' }
		}
		,id: this.props.match.params.id || null
	};

	componentDidMount() {
		if (!this.state.id){
			this.setState({ loading: false });
			return;
		}
		console.log(this.context);
		this.context.fetchById(this.state.id).then( user => {
			console.log(user);
			let out = {};
			Object.keys(user).forEach( key => {
				out[key] = { value: user[key] };
			});
			this.setState(({ fields }) => ({
				fields: { ...fields, ...out }
				,id: user.id
			}));
			this.setState({ loading: false });
		});
	}

	handleFormChange = (changedFields) => {
		//console.log('handle form change', changedFields);
		this.setState(({ fields }) => ({
			fields: { ...fields, ...changedFields },
		}));
	}

	handleSubmit = (values) => {
		console.log('Received values of form: ', values);
		console.log(this.state);
		this.setState({ saving: true });
		let promise;
		if (this.state.id){
			let patch = { ...values, id: this.state.id };
			if (!patch.password){
				delete patch.password;
			}
			promise = this.context.update(patch).then( () => {
				this.setState({ saving: false });
			});
		} else {
			promise = this.context.insert(values).then( (user) => {
				this.setState({ id: user.id, saving: false });
			});
		}
		promise.then( () => {
			notification.success({
				message: 'Success',
				description: 'User saved successfully',
				duration: 4
			});
		}).catch( (err) => {
			notification.error({
				message: 'Error',
				description: `Cannot save the user. Please try again.\n${err && err.message || ''}`,
				duration: 8
			});
			this.setState({ saving: false });
		});
	}

	render(){
		const fields = this.state.fields;

		return (
		<React.Fragment>
			<Typography.Title level={3}>{ this.state.id ? 'User detail' : 'New user' } { this.state.loading ? <Spin size="default" /> : null }</Typography.Title>
			<Card>
				<Skeleton active loading={this.state.loading} paragraph={{ rows: 3 }}>
					<UserDetailForm
						{...fields}
						userId={this.state.id} saving={this.state.saving}
						onChange={this.handleFormChange} onSubmit={this.handleSubmit}
					/>
				</Skeleton>
			</Card>
		</React.Fragment>
		);
	}
}


export { Users, UserDetail };

